import copy from 'copy-to-clipboard';
import { dispatch } from 'nike-re-framejs';
import { Button } from 'nike-ui/src/components/button/Button';
import React from 'react';

import i18n from '@i18n';
import CopyIcon from '@/icons/CopyIcon';
import PopupNg from '@/ui/PopupNg';

function CopyLink({ publicUrl }) {
    function onClick() {
        PopupNg.dispatcher.close('ticketDetail');
        PopupNg.dispatcher.close('betbook/ticketDetailPopup');
        const copyClipBoardOptions = { debug: true, message: i18n('react.ticket.copyClipboard.message') };

        if (copy(publicUrl, copyClipBoardOptions)) {
            dispatch(['ui.showPopup', 'react.ticket.copyClipboard.success']);
        }
    }

    return (
        <Button
            className="blue"
            icon={CopyIcon}
            dataAtid="ticket-detail-url"
            label={i18n('tiket.detailTiketu.copyURL')}
            onClick={onClick}
        />
    );
}

export default CopyLink;
